import { useEffect } from 'react';

const TWITTER_CARD_DEFAULT = 'summary_large_image';

const TAG_SPECS = [
  { key: 'description',   selector: 'meta[name="description"]',           attr: 'name',     name: 'description' },
  { key: 'keywords',      selector: 'meta[name="keywords"]',              attr: 'name',     name: 'keywords' },
  { key: 'ogTitle',       selector: 'meta[property="og:title"]',          attr: 'property', name: 'og:title' },
  { key: 'ogUrl',         selector: 'meta[property="og:url"]',            attr: 'property', name: 'og:url' },
  { key: 'ogDescription', selector: 'meta[property="og:description"]',    attr: 'property', name: 'og:description' },
  { key: 'twitterTitle',  selector: 'meta[property="twitter:title"]',     attr: 'property', name: 'twitter:title' },
  { key: 'twitterCard',   selector: 'meta[property="twitter:card"]',      attr: 'property', name: 'twitter:card' },
];

function upsertMeta(spec, value) {
  let el = document.head.querySelector(spec.selector);
  const created = !el;
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(spec.attr, spec.name);
    document.head.appendChild(el);
  }
  const previous = el.getAttribute('content');
  el.setAttribute('content', value);
  return { el, created, previous };
}

export default function useMeta(seo) {
  useEffect(() => {
    if (!seo) return undefined;

    const applied = [];
    const twitterCard = seo.twitterCard || TWITTER_CARD_DEFAULT;
    const values = { ...seo, twitterCard };

    for (const spec of TAG_SPECS) {
      const value = values[spec.key];
      if (value == null || value === '') continue;
      applied.push({ spec, ...upsertMeta(spec, value) });
    }

    return () => {
      for (const entry of applied) {
        if (entry.created) {
          entry.el.remove();
        } else if (entry.previous != null) {
          entry.el.setAttribute('content', entry.previous);
        }
      }
    };
  }, [seo]);
}
